import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { loginUser, registerUser } from '../services/api';
import CloseIcon from '@mui/icons-material/Close';

function AuthModal({ onClose, onSuccess }) {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { colors } = useTheme();

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    setError('');
    if (mode === 'login') {
      if (!form.email || !form.password) return setError('Rellena todos los campos');
      setLoading(true);
      try {
        const res = await loginUser({ email: form.email, password: form.password });
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        onSuccess();
      } catch (err) {
        setError(err.response?.data?.error || 'Email o contraseña incorrectos');
      }
      setLoading(false);
    } else {
      if (!form.name || !form.email || !form.password || !form.confirmPassword) return setError('Rellena todos los campos');
      if (form.password !== form.confirmPassword) return setError('Las contraseñas no coinciden');
      if (form.password.length < 6) return setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(true);
      try {
        const res = await registerUser({ name: form.name, email: form.email, password: form.password });
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        onSuccess();
      } catch (err) {
        setError(err.response?.data?.error || 'Error al registrarse');
      }
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ backgroundColor: colors.bgSecondary, borderRadius: '16px', border: `1px solid ${colors.border}`, padding: '2.5rem', width: '100%', maxWidth: '420px', position: 'relative' }}>
        
        <button style={{ position: 'absolute', top: '1rem', right: '1rem', backgroundColor: 'transparent', border: 'none', color: colors.textSecondary, cursor: 'pointer' }} onClick={onClose}>
          <CloseIcon />
        </button>

        <h2 style={{ color: colors.text, fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
          {mode === 'login' ? 'Inicia sesión para continuar' : 'Crea tu cuenta'}
        </h2>
        <p style={{ color: colors.textSecondary, fontSize: '0.9rem', marginBottom: '1.5rem' }}>
          {mode === 'login' ? 'Necesitas una cuenta para comprar entradas' : 'Únete a Galiticket y compra tus entradas'}
        </p>

        {/* TABS */}
        <div style={{ display: 'flex', backgroundColor: colors.bgTertiary, borderRadius: '10px', padding: '4px', marginBottom: '1.5rem' }}>
          <button style={{ flex: 1, padding: '0.5rem', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem', backgroundColor: mode === 'login' ? colors.accent : 'transparent', color: mode === 'login' ? colors.accentText : colors.textSecondary, transition: 'all 0.2s' }} onClick={() => { setMode('login'); setError(''); }}>
            Iniciar sesión
          </button>
          <button style={{ flex: 1, padding: '0.5rem', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem', backgroundColor: mode === 'register' ? colors.accent : 'transparent', color: mode === 'register' ? colors.accentText : colors.textSecondary, transition: 'all 0.2s' }} onClick={() => { setMode('register'); setError(''); }}>
            Registrarse
          </button>
        </div>

        {error && (
          <div style={{ backgroundColor: '#ff444422', border: '1px solid #ff4444', color: '#ff4444', padding: '0.8rem 1rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.9rem' }}>
            {error}
          </div>
        )}

        {mode === 'register' && (
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Nombre completo</label>
            <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.7rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name="name" placeholder="Tu nombre" value={form.name} onChange={handleChange} />
          </div>
        )}

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Email</label>
          <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.7rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name="email" type="email" placeholder="tu@email.com" value={form.email} onChange={handleChange} />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Contraseña</label>
          <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.7rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name="password" type="password" placeholder="Mínimo 6 caracteres" value={form.password} onChange={handleChange} />
        </div>

        {mode === 'register' && (
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ color: colors.textSecondary, fontSize: '0.85rem', display: 'block', marginBottom: '0.4rem' }}>Confirmar contraseña</label>
            <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: '0.7rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name="confirmPassword" type="password" placeholder="Repite la contraseña" value={form.confirmPassword} onChange={handleChange} />
          </div>
        )}

        <button style={{ backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.9rem', borderRadius: '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem', width: '100%', marginTop: '0.5rem' }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Cargando...' : mode === 'login' ? 'Iniciar sesión' : 'Crear cuenta'}
        </button>
      </div>
    </div>
  );
}

export default AuthModal;